/** @jsxImportSource @emotion/react */
import React from 'react';
import {
  Box,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import {
  setHasFrenchSocialSecurity,
  nextStep,
  prevStep,
  setStepVerified,
} from '../santeMobiliteSlice';

const SocialSecurityStep = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('sante-mobilite');
  const hasFrenchSocialSecurity = useAppSelector(
    state => state.santeMobilite.hasFrenchSocialSecurity,
  );

  const answer =
    hasFrenchSocialSecurity === true
      ? 'yes'
      : hasFrenchSocialSecurity === false
      ? 'no'
      : '';

  const canProceed =
    hasFrenchSocialSecurity === true || hasFrenchSocialSecurity === false;

  // On commit la réponse directement en Redux, comme les steps Dates et
  // Destination : pas de useState intermédiaire. L'utilisateur peut donc
  // naviguer via le stepper après avoir choisi sa réponse sans avoir à cliquer
  // "Suivant" — sa réponse suit et le prix est invalidé automatiquement par le
  // reducer setHasFrenchSocialSecurity.
  const handleAnswerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.target.value === 'yes';
    dispatch(setHasFrenchSocialSecurity(next));
  };

  const handleNext = () => {
    if (!canProceed) return;
    dispatch(setStepVerified(3));
    dispatch(nextStep());
  };

  return (
    <Box sx={{ maxWidth: 500, mx: 'auto', p: 2 }}>
      <Typography variant="subtitle1" gutterBottom mb={0}>
        {t('step3.title')}
      </Typography>

      <Typography variant="body2" color="text.secondary" mt={1}>
        {t('step3.subtitle')}
      </Typography>

      <Box mt={3} display="flex" justifyContent="center">
        <RadioGroup
          row
          value={answer}
          onChange={handleAnswerChange}
          name="hasFrenchSocialSecurity"
        >
          <FormControlLabel value="yes" control={<Radio />} label={t('step3.yes')} />
          <FormControlLabel value="no" control={<Radio />} label={t('step3.no')} />
        </RadioGroup>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
        <Button onClick={() => dispatch(prevStep())} variant="outlined">
          {t('common_actions.back')}
        </Button>
        <Button onClick={handleNext} disabled={!canProceed} variant="contained">
          {t('common_actions.next')}
        </Button>
      </Box>
    </Box>
  );
};

export default SocialSecurityStep;
